let isFinished = false;

function captureElement(elementId) {
    const element = document.getElementById(elementId);
    if (!element) {
        return Promise.resolve(null);
    }

    const originalDisplay = 'none';
    if (elementId.includes('Text')) {
        element.style.display = 'flex';
    } else {
        element.style.display = 'block';
    }

    const internalElements = element.querySelectorAll('*:not(.center-line)');
    const originalDisplayStyles = [];
    internalElements.forEach(internalElement => {
        originalDisplayStyles.push(internalElement.style.display);
        internalElement.style.display = 'flex';
    });

    return html2canvas(element, {
        backgroundColor: null,
        scale: 1,
        logging: false,
        width: element.clientWidth,
        height: element.clientHeight,
        removeContainer: true,
        ignoreElements: (el) => {
            const id = el.id || '';
            const classList = (el.className || '').toString();
        
            return (
                el.closest('header') ||
                el.closest('footer') ||
                el.classList.contains('predictive-search') ||
                el.classList.contains('cart-drawer') ||
                el.classList.contains('site-header') ||
                el.classList.contains('site-footer') ||
                el.id === 'shopify-chat' || // Optional
                el.tagName === 'SCRIPT' ||                    // All <script> tags
                el.tagName === 'STYLE' ||                       // Inline <style> tags that could interfere
                classList.includes('cart-drawer') ||            // Cart drawer
                classList.includes('drawer__inner') ||          // Nested cart drawer content
                classList.includes('predictive-search') ||
                classList.includes('predictive-search__input') ||  // <== 🔒 Prevent main.js crash
                classList.includes('predictive-search__results') ||      // Search auto-suggest
                classList.includes('site-header') ||
                classList.includes('site-footer') ||
                classList.includes('announcement-bar') ||       // Announcement bar (frequently animated)
                classList.includes('list-menu') ||              // Navigation menus
                classList.includes('menu-drawer') ||            // Mobile nav drawer
                classList.includes('modal') ||                  // Any modals or popups
                classList.includes('tooltip') ||                // Hover info/tooltips
                classList.includes('breadcrumbs') ||            // Optional, if not part of preview
                classList.includes('form__input') ||
                classList.includes('field__input')             
            );
        },
    }).then(canvas => {
        element.style.display = originalDisplay;
        internalElements.forEach((el, i) => el.style.display = originalDisplayStyles[i]);

        const overlay = document.getElementById(elementId.replace('Canvas', 'TextOverlay'));
        if (overlay && overlay.style.clipPath && elementId.includes('Text')) {
            const clipPath = overlay.style.clipPath.replace('path("', '').replace('")', '');

            try {
                const tempCanvas = document.createElement('canvas');
                tempCanvas.width = canvas.width;
                tempCanvas.height = canvas.height;
                const tempCtx = tempCanvas.getContext('2d');

                const pathCommands = clipPath.split(/(?=[MLQZ])/);
                tempCtx.beginPath();
                for (let cmd of pathCommands) {
                    const parts = cmd.trim().split(/[ ,]+/);
                    const command = parts[0];
                    const params = parts.slice(1).map(parseFloat);
                    switch (command) {
                        case 'M': tempCtx.moveTo(params[0], params[1]); break;
                        case 'L': tempCtx.lineTo(params[0], params[1]); break;
                        case 'Q': tempCtx.quadraticCurveTo(params[0], params[1], params[2], params[3]); break;
                        case 'Z': tempCtx.closePath(); break;
                        default: console.error(`Unsupported path command: ${command}`);
                    }
                }
                tempCtx.clip();
                tempCtx.drawImage(canvas, 0, 0);
                return tempCanvas.toDataURL("image/png");
            } catch (e) {
                console.error(`clipPath failed for ${elementId}`, e);
                return canvas.toDataURL("image/png");
            }
        } else {
            return canvas.toDataURL("image/png");
        }
    }).catch(err => {
        element.style.display = originalDisplay;
        internalElements.forEach((el, i) => el.style.display = originalDisplayStyles[i]);
        console.error(`Error capturing ${elementId}:`, err);
        return null;
    });
}

async function previewNow() {
    isProcessing = true;

    try {
        // Show loading overlay
        document.getElementById('TentDescription').style.display = 'none';
        document.getElementById('tent-setup-button').style.display = 'none';
        document.getElementById('loadingOverlay').style.display = 'flex';

        // Hide all other sections and show the preview section
        document.querySelectorAll('.section').forEach(section => {
            section.style.display = 'none';
        });
        document.getElementById('preview-section').style.display = 'block';

        document.getElementById('toggleSnapGrid').style.visibility = 'hidden';

        // Hide all side canvases
        document.getElementById('FrontPeakCanvas').style.display = 'none';
        document.getElementById('FrontValanceCanvas').style.display = 'none';
        document.getElementById('FrontPeakTextOverlay').style.display = 'none';
        document.getElementById('FrontValanceTextOverlay').style.display = 'none';
        document.getElementById('ValanceLogo').style.display = 'none';

        document.getElementById('BackPeakCanvas').style.display = 'none';
        document.getElementById('BackValanceCanvas').style.display = 'none';
        document.getElementById('BackWallCanvas').style.display = 'none';
        document.getElementById('BackPeakTextOverlay').style.display = 'none';
        document.getElementById('BackValanceTextOverlay').style.display = 'none';
        document.getElementById('BackWallTextOverlay').style.display = 'none';

        document.getElementById('RightPeakCanvas').style.display = 'none';
        document.getElementById('RightValanceCanvas').style.display = 'none';
        document.getElementById('RightWallCanvas').style.display = 'none';
        document.getElementById('RightPeakTextOverlay').style.display = 'none';
        document.getElementById('RightValanceTextOverlay').style.display = 'none';
        document.getElementById('RightWallTextOverlay').style.display = 'none';

        document.getElementById('LeftPeakCanvas').style.display = 'none';
        document.getElementById('LeftValanceCanvas').style.display = 'none';
        document.getElementById('LeftWallCanvas').style.display = 'none';
        document.getElementById('LeftPeakTextOverlay').style.display = 'none';
        document.getElementById('LeftValanceTextOverlay').style.display = 'none';
        document.getElementById('LeftWallTextOverlay').style.display = 'none';

        const previewer = document.getElementById('tentPreviewCanvas');
        const previewImage = document.getElementById('tentPreviewImage');
        document.getElementById('infoTitle').textContent = 'Contact Information';

        previewer.style.display = 'none';
        previewImage.style.display = 'none';
        previewImage.src = '';

        document.body.style.cursor = 'progress';

        await delay(100);

        const canvas = document.getElementById('tentPreviewCanvas');
        const ctx = canvas.getContext('2d');

        // Optional but usually a good idea before redrawing
        ctx.clearRect(0, 0, canvas.width, canvas.height);

        let imgScale = 1;
        let sides = [];

        if (itType) {
            document.getElementById("tentPreviewImage").style.transform = 'scale(1.5)';
            if (size == 20) {
                sides = [
                    { peakId: 'FrontPeakCanvas', valanceId: 'FrontValanceCanvas', wallId: null, peakOverlayId: 'FrontPeakTextOverlay', valanceOverlayId: 'FrontValanceTextOverlay', wallOverlayId: null, x: 350, y: 550, rotation: 0, title: 'Front' },
                    { peakId: 'BackPeakCanvas', valanceId: 'BackValanceCanvas', wallId: 'BackWallCanvas', peakOverlayId: 'BackPeakTextOverlay', valanceOverlayId: 'BackValanceTextOverlay', wallOverlayId: 'BackWallTextOverlay', x: 350, y: -50, rotation: Math.PI, title: 'Back' },
                    { peakId: 'RightPeakCanvas', valanceId: 'RightValanceCanvas', wallId: 'RightWallCanvas', peakOverlayId: 'RightPeakTextOverlay', valanceOverlayId: 'RightValanceTextOverlay', wallOverlayId: 'RightWallTextOverlay', x: 810, y: 250, rotation: -Math.PI / 2, title: 'Right' },
                    { peakId: 'LeftPeakCanvas', valanceId: 'LeftValanceCanvas', wallId: 'LeftWallCanvas', peakOverlayId: 'LeftPeakTextOverlay', valanceOverlayId: 'LeftValanceTextOverlay', wallOverlayId: 'LeftWallTextOverlay', x: -110, y: 250, rotation: Math.PI / 2, title: 'Left' }
                ];
            } else if (size == 15) {
                sides = [
                    { peakId: 'FrontPeakCanvas', valanceId: 'FrontValanceCanvas', wallId: null, peakOverlayId: 'FrontPeakTextOverlay', valanceOverlayId: 'FrontValanceTextOverlay', wallOverlayId: null, x: 350, y: 550, rotation: 0, title: 'Front' },
                    { peakId: 'BackPeakCanvas', valanceId: 'BackValanceCanvas', wallId: 'BackWallCanvas', peakOverlayId: 'BackPeakTextOverlay', valanceOverlayId: 'BackValanceTextOverlay', wallOverlayId: 'BackWallTextOverlay', x: 350, y: -50, rotation: Math.PI, title: 'Back' },
                    { peakId: 'RightPeakCanvas', valanceId: 'RightValanceCanvas', wallId: 'RightWallCanvas', peakOverlayId: 'RightPeakTextOverlay', valanceOverlayId: 'RightValanceTextOverlay', wallOverlayId: 'RightWallTextOverlay', x: 740, y: 250, rotation: -Math.PI / 2, title: 'Right' },
                    { peakId: 'LeftPeakCanvas', valanceId: 'LeftValanceCanvas', wallId: 'LeftWallCanvas', peakOverlayId: 'LeftPeakTextOverlay', valanceOverlayId: 'LeftValanceTextOverlay', wallOverlayId: 'LeftWallTextOverlay', x: -40, y: 250, rotation: Math.PI / 2, title: 'Left' }
                ];
            } else {
                sides = [
                    { peakId: 'FrontPeakCanvas', valanceId: 'FrontValanceCanvas', wallId: null, peakOverlayId: 'FrontPeakTextOverlay', valanceOverlayId: 'FrontValanceTextOverlay', wallOverlayId: null, x: 350, y: 550, rotation: 0, title: 'Front' },
                    { peakId: 'BackPeakCanvas', valanceId: 'BackValanceCanvas', wallId: 'BackWallCanvas', peakOverlayId: 'BackPeakTextOverlay', valanceOverlayId: 'BackValanceTextOverlay', wallOverlayId: 'BackWallTextOverlay', x: 350, y: -50, rotation: Math.PI, title: 'Back' },
                    { peakId: 'RightPeakCanvas', valanceId: 'RightValanceCanvas', wallId: 'RightWallCanvas', peakOverlayId: 'RightPeakTextOverlay', valanceOverlayId: 'RightValanceTextOverlay', wallOverlayId: 'RightWallTextOverlay', x: 650, y: 250, rotation: -Math.PI / 2, title: 'Right' },
                    { peakId: 'LeftPeakCanvas', valanceId: 'LeftValanceCanvas', wallId: 'LeftWallCanvas', peakOverlayId: 'LeftPeakTextOverlay', valanceOverlayId: 'LeftValanceTextOverlay', wallOverlayId: 'LeftWallTextOverlay', x: 50, y: 250, rotation: Math.PI / 2, title: 'Left' }
                ];
            }
        } else {
            document.getElementById("tentPreviewImage").style.transform = 'scale(2.5)';
            if (size == 20) {
                sides = [
                    { peakId: 'FrontPeakCanvas', valanceId: 'FrontValanceCanvas', wallId: null, peakOverlayId: 'FrontPeakTextOverlay', valanceOverlayId: 'FrontValanceTextOverlay', wallOverlayId: null, x: 350, y: 550, rotation: 0, title: 'Front' },
                    { peakId: 'BackPeakCanvas', valanceId: 'BackValanceCanvas', wallId: null, peakOverlayId: 'BackPeakTextOverlay', valanceOverlayId: 'BackValanceTextOverlay', wallOverlayId: null, x: 350, y: -50, rotation: Math.PI, title: 'Back' },
                    { peakId: 'RightPeakCanvas', valanceId: 'RightValanceCanvas', wallId: null, peakOverlayId: 'RightPeakTextOverlay', valanceOverlayId: 'RightValanceTextOverlay', wallOverlayId: null, x: 810, y: 250, rotation: -Math.PI / 2, title: 'Right' },
                    { peakId: 'LeftPeakCanvas', valanceId: 'LeftValanceCanvas', wallId: null, peakOverlayId: 'LeftPeakTextOverlay', valanceOverlayId: 'LeftValanceTextOverlay', wallOverlayId: null, x: -110, y: 250, rotation: Math.PI / 2, title: 'Left' }
                ];
            } else if (size == 15) {
                sides = [
                    { peakId: 'FrontPeakCanvas', valanceId: 'FrontValanceCanvas', wallId: null, peakOverlayId: 'FrontPeakTextOverlay', valanceOverlayId: 'FrontValanceTextOverlay', wallOverlayId: null, x: 350, y: 550, rotation: 0, title: 'Front' },
                    { peakId: 'BackPeakCanvas', valanceId: 'BackValanceCanvas', wallId: null, peakOverlayId: 'BackPeakTextOverlay', valanceOverlayId: 'BackValanceTextOverlay', wallOverlayId: null, x: 350, y:  -50, rotation: Math.PI, title: 'Back' },
                    { peakId: 'RightPeakCanvas', valanceId: 'RightValanceCanvas', wallId: null, peakOverlayId: 'RightPeakTextOverlay', valanceOverlayId: 'RightValanceTextOverlay', wallOverlayId: null, x: 740, y: 250, rotation: -Math.PI / 2, title: 'Right' },
                    { peakId: 'LeftPeakCanvas', valanceId: 'LeftValanceCanvas', wallId: null, peakOverlayId: 'LeftPeakTextOverlay', valanceOverlayId: 'LeftValanceTextOverlay', wallOverlayId: null, x: -40, y: 250, rotation: Math.PI / 2, title: 'Left' }
                ];
            } else {
                sides = [
                    { peakId: 'FrontPeakCanvas', valanceId: 'FrontValanceCanvas', wallId: null, peakOverlayId: 'FrontPeakTextOverlay', valanceOverlayId: 'FrontValanceTextOverlay', wallOverlayId: null, x: 350, y: 550, rotation: 0, title: 'Front' },
                    { peakId: 'BackPeakCanvas', valanceId: 'BackValanceCanvas', wallId: null, peakOverlayId: 'BackPeakTextOverlay', valanceOverlayId: 'BackValanceTextOverlay', wallOverlayId: null, x: 350, y: -50, rotation: Math.PI, title: 'Back' },
                    { peakId: 'RightPeakCanvas', valanceId: 'RightValanceCanvas', wallId: null, peakOverlayId: 'RightPeakTextOverlay', valanceOverlayId: 'RightValanceTextOverlay', wallOverlayId: null, x: 650, y: 250, rotation: -Math.PI / 2, title: 'Right' },
                    { peakId: 'LeftPeakCanvas', valanceId: 'LeftValanceCanvas', wallId: null, peakOverlayId: 'LeftPeakTextOverlay', valanceOverlayId: 'LeftValanceTextOverlay', wallOverlayId: null, x: 50, y: 250, rotation: Math.PI / 2, title: 'Left' }
                ];
            }
        }

        document.getElementById("loading-progress").innerText = `Generating side previews...`;

        const promises = sides.map(async (side) => {
            const combinedImage = await captureAndCombineSide(side);
            if (!combinedImage) return;

            if(side.peakId.includes("Front")){
                capturedImages.Front = combinedImage;
            }
            if(side.peakId.includes("Back")){
                capturedImages.Back = combinedImage;
            }

            if(side.peakId.includes("Right")){
                capturedImages.Right = combinedImage;
            }

            else if(side.peakId.includes("Left")){
                capturedImages.Left = combinedImage;
            }


            const img = new Image();
            img.src = combinedImage;

            await new Promise((resolve, reject) => {
                img.onload = resolve;
                img.onerror = reject;
            });

            ctx.save();
            ctx.translate(
                side.x + (img.width * imgScale) / 2,
                side.y + (img.height * imgScale) / 2
            );
            ctx.rotate(side.rotation);
            ctx.drawImage(
                img,
                -(img.width * imgScale) / 2,
                -(img.height * imgScale) / 2,
                img.width * imgScale,
                img.height * imgScale
            );
            ctx.restore();
        });

        await Promise.all(promises);

        document.getElementById("loading-progress").innerText = `Combining all previews...`;

        const dataUrl = canvas.toDataURL("image/png");
        previewImage.src = dataUrl;
        previewImage.style.display = 'block';

        document.getElementById('TentDescription').style.display = 'block';
        isFinished = true;
        document.body.style.cursor = 'default';
    } catch (err) {
        console.error('Error combining snapshots:', err);
        document.body.style.cursor = 'default';
    } finally {
        document.getElementById('loadingOverlay').style.display = 'none';
        document.getElementById("loading-progress").innerText = `Generating preview, please wait...`;
        isProcessing = false;
        console.log(capturedImages);
    }
}


function goBackToSections() {
    if(isFinished){
        // Hide the preview section and show the sections container
        document.getElementById('preview-section').style.display = 'none';
        document.getElementById('sections-container').style.display = 'block';
        document.getElementById('loadingOverlay').style.display = 'none';
        document.getElementById('ValanceLogo2').style.display = 'none';
        document.getElementById('toggleSnapGrid').style.visibility = 'visible'; 
        const previewer = document.getElementById('tentPreviewCanvas');
        const previewImage = document.getElementById('tentPreviewImage');
        document.getElementById('infoTitle').textContent = 'Select Options';
        previewer.style.display = 'none';
        previewImage.style.display = 'none';
        currentSection = totalSections;
        let tab = '';
        tab = prevTab(currentTab);
        switchTab(tab);
        showSection(currentSection);
        isFinished = false;
    }
}

function gatherSectionInformation(sectionsConfig) {
    const sectionData = sectionsConfig.map(section => {
        const selectedColor = document.getElementById(`selected-color-${section.id}`).textContent;
        const text = document.getElementById(`text-input-${section.id}`).value.trim();
        const fontStyle = document.querySelector(`#font-style-${section.id}`).previousElementSibling.textContent.trim();
        const fontColor = document.getElementById(`font-color-${section.id}`).textContent.trim();
        const outlineColor = document.getElementById(`outline-color-${section.id}`).textContent.trim();
        const images = Array.from(document.querySelectorAll(`#art-preview-${section.id} img`)).map(img => img.src);
        const notes = document.getElementById(`notes-${section.id}`).value.trim();

        return {
            sectionId: section.id,
            sectionTitle: section.title,
            selectedColor,
            text,
            fontStyle,
            fontColor,
            outlineColor,
            images,
            notes
        };
    });

    // Gather contact information
    const contactInformation = {
        email: document.getElementById('email').value.trim(),
        userName: document.getElementById('userName').value.trim(),
        phone: document.getElementById('phone').value.trim(),
        schoolClub: document.getElementById('schoolClub').value.trim(),
        street: document.getElementById('street').value.trim(),
        city: document.getElementById('city').value.trim(),
        state: document.getElementById('state').value.trim(),
        zip: document.getElementById('zip').value.trim(),
        priority: document.getElementById('priority').value.trim(),
        tentName: document.getElementById('Tent-Name').value.trim(),
        salesRep: document.getElementById('salesRep').value.trim()
    };

    const previewURL = document.getElementById('tentPreviewImage').src;

    return { sectionData, contactInformation, previewURL };
}

async function submitForm(){
    if(validateForm()){
        showSubmissionModal();
    }
}

function showSubmissionModal() {
    const modal = document.getElementById('confirm-submission-modal');
    modal.style.display = 'block';
}

function closeSubmissionModal() {
    const modal = document.getElementById('confirm-submission-modal');
    modal.style.display = 'none';
}

var submission = false;

async function submitDesign() {
    let pdfFinished = false;
    submission = true;
    closeSubmissionModal();
    if (submission == true) {
        const { sectionData, contactInformation, previewURL } = gatherSectionInformation(sectionsConfig);
        document.getElementById('TentDescription').style.display = 'none';
        document.getElementById('loadingOverlay2').style.display = 'flex';
        isProcessing = true;
        document.body.style.cursor = 'progress';

        try {
            const result = await createPdf(sectionData, contactInformation, previewURL, {
                mode: 'cart'
            });

            if (result?.rackspaceUpload?.objectName) {
                document.getElementById('loading-progress2').innerText = 'Adding tent to cart...';
                await addBuilderTentToCart(contactInformation, result.rackspaceUpload);
                return;
            }

            throw new Error('PDF upload data missing');
        } catch (err) {
            console.error(err);
            alert('We could not add this tent to cart. Please try again.');
        } finally {
            document.getElementById('loadingOverlay2').style.display = 'none';
            document.body.style.cursor = 'default';
            isProcessing = false;
        }
    }
}

document.addEventListener('DOMContentLoaded', () => {
    // Ensure all overlays are correctly positioned and sized initially
    const sections = ['Front Peak', 'Front Valance'];
    sections.forEach(section => updateOverlayPositionAndSize(section));
    
});

var isProcessing = false;

window.addEventListener('beforeunload', function (e) {
    e.preventDefault();
    e.returnValue = '';
});

async function captureAndCombineSide(sideConfig) {
    const { peakId, valanceId, wallId, peakOverlayId, valanceOverlayId, wallOverlayId, title } = sideConfig;

    const peakImage = await captureElement(peakId);
    const valanceImage = await captureElement(valanceId);
    const wallImage = wallId ? await captureElement(wallId) : null;

    const shouldCapture = (overlayId) => {
        const el = document.getElementById(overlayId);
        if (!el) return false;

        return !!(
            el.querySelector('.editable-text .text-content') ||
            el.querySelector('.editable-art')
        );
    };
    
    const peakOverlayImage = shouldCapture(peakOverlayId) ? await captureElement(peakOverlayId) : null;
    const valanceOverlayImage = shouldCapture(valanceOverlayId) ? await captureElement(valanceOverlayId) : null;
    const wallOverlayImage = wallOverlayId && shouldCapture(wallOverlayId) ? await captureElement(wallOverlayId) : null;
    

    // Create the canvas with desired dimensions
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    canvas.width = 800; // Adjust width as needed
    canvas.height = 600; // Adjust height as needed

    const imgScale = 1; // Adjust scaling as needed
    let yOffset = 0;

    const images = [
        { image: peakImage, overlay: peakOverlayImage, type: 'peak' },
        { image: valanceImage, overlay: valanceOverlayImage, type: 'valance' },
        { image: wallImage, overlay: wallOverlayImage, type: 'wall' }
    ];

    for (const { image, overlay, type } of images) {
        if (image) {
            let valXPos = 0;
            let valYPos = 0;
            const img = new Image();
            img.src = image;
            await new Promise(resolve => {
                img.onload = () => {
                    const xPosition = (canvas.width - img.width * imgScale) / 2;
                    ctx.drawImage(img, xPosition, yOffset, img.width * imgScale, img.height * imgScale);
                    yOffset += img.height * imgScale;
                    valXPos = xPosition;
                    valYPos = yOffset;
                    resolve();
                };
            });

            if (overlay) {
                const overlayImg = new Image();
                overlayImg.src = overlay;
                await new Promise(resolve => {
                    overlayImg.onload = () => {
                        const xPosition = (canvas.width - overlayImg.width * imgScale) / 2;
                        ctx.drawImage(overlayImg, xPosition, yOffset - img.height * imgScale, overlayImg.width * imgScale, overlayImg.height * imgScale);
                        resolve();
                    };
                });
            }

            // Draw the brand logo immediately after the valance is drawn
            if (title.includes('Front') && type === 'valance') {
                console.log("EMBEDING LOGO");
                const brandLogo = new Image();
                brandLogo.src = document.getElementById('ValanceLogo').src;
                brandLogo.width = 25; // Set the width to match the CSS
                brandLogo.height = brandLogo.width * (brandLogo.naturalHeight / brandLogo.naturalWidth); // Maintain aspect ratio

                await new Promise(resolve => {
                    brandLogo.onload = () => {
                        const logoXPosition = valXPos + img.width * imgScale - brandLogo.width - 5;
                        const logoYPosition = valYPos - img.height * imgScale + 5;
                        ctx.drawImage(brandLogo, logoXPosition, logoYPosition, brandLogo.width, brandLogo.height);
                        resolve();
                    };
                });
            }
        }
    }

    return canvas.toDataURL("image/png");
}


function delay(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

